var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contracts',{attrs:{"contractInfo":_vm.contractInfo(),"currentSource":_vm.$store.getters['contract/currentSource'],"invoices":_vm.$store.state.contract.invoices,"handleOnSelectYearChange":_vm.handleOnSelectYearChange}})}
var staticRenderFns = []

export { render, staticRenderFns }